import {themeConfig} from '../theme/themeConfig';

/** URL of the current event's API, e.g. `eventUrl('/news')` -> `/api/v1/events/1/news`. */
export function eventUrl(path = ''): string {
  return `/api/v1/events/${themeConfig().eventId}${path}`;
}
